import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

const NOTIFICATIONS = [
  {
    id: 1001,
    title: '🥋 ¡Tu oponente te espera!',
    body: 'Hace 2 días que no entrenas. ¡No pierdas tu racha, Maestro!',
    delayDays: 2,
  },
  {
    id: 1002,
    title: '⚡ ¡Tu energía está al máximo!',
    body: 'Tienes energía acumulada. ¡Entra y úsala antes de perderla!',
    delayDays: 3,
  },
  {
    id: 1003,
    title: '🏆 ¡Estás perdiendo posiciones en el Ranking!',
    body: 'Otros guerreros están subiendo. ¡Vuelve a pelear y recupera tu lugar!',
    delayDays: 5,
  },
  {
    id: 1004,
    title: '🔥 ¡Tu cinturón se está oxidando!',
    body: 'Llevas una semana sin pelear, guerrero/a. ¡Vuelve al dojang y demuestra tu nivel!',
    delayDays: 7,
  },
  {
    id: 1005,
    title: '🎰 ¡Tu premio diario te espera!',
    body: 'La ruleta diaria está lista. ¡Girá y ganá protectores, monedas o stats gratis!',
    delayDays: 1,
  },
];

export async function scheduleInactivityNotifications() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { display } = await LocalNotifications.checkPermissions();
    if (display !== 'granted') {
      const result = await LocalNotifications.requestPermissions();
      if (result.display !== 'granted') return;
    }

    // Cancelar anteriores y reprogramar desde ahora
    await LocalNotifications.cancel({
      notifications: NOTIFICATIONS.map(n => ({ id: n.id })),
    });

    const scheduled = NOTIFICATIONS.map(n => ({
      id: n.id,
      title: n.title,
      body: n.body,
      schedule: {
        at: new Date(Date.now() + n.delayDays * 24 * 60 * 60 * 1000),
        allowWhileIdle: true,
      },
      sound: 'default',
      smallIcon: 'ic_launcher',
      largeIcon: 'ic_launcher',
    }));

    await LocalNotifications.schedule({ notifications: scheduled });
    console.log('Notificaciones de inactividad programadas');
  } catch (err) {
    console.error('Error programando notificaciones:', err);
  }
}
